import { combineReducers } from 'redux'
import planets from './planets'

const exoplanetApp = combineReducers({
  planets
})

export default exoplanetApp



// WEBPACK FOOTER //
// ./src/reducers/index.js